import DashboardBox from './DashboardBox';
import DashboardBox2 from './DashboardBox2';
import DashboardBox3 from './DashboardBox3';
import DashboardBox4 from './DashboardBox4';
import DashboardBox5 from './DashboardBox5';
import DashboardBox6 from './DashboardBox6';
import DashboardBox7 from './DashboardBox7';
import DashboardBox8 from './DashboardBox8';

export {
	DashboardBox,
	DashboardBox2,
	DashboardBox3,
	DashboardBox4,
	DashboardBox5,
	DashboardBox6,
	DashboardBox7,
	DashboardBox8
}
